export const GIFT_LINK = {
  GIFT_LINK_EXPIRATION_MS: 60 * 60 * 24 * 14 * 1000, // 14 Days
  LOCAL_STORAGE_NAME: 'giftbox-gift-links',
};
